"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TOKEN_UPDATE_ACTION = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _lodash = _interopRequireDefault(require("lodash"));

var TOKEN_UPDATE_ACTION = 'NARRATE-SDK/TOKENS/UPDATE';
exports.TOKEN_UPDATE_ACTION = TOKEN_UPDATE_ACTION;

var ReduxTokenStore = /*#__PURE__*/function () {
  function ReduxTokenStore(store) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, ReduxTokenStore);
    this.storeKey = options.storeKey || 'tokens';
    this.store = store;
  }

  (0, _createClass2["default"])(ReduxTokenStore, [{
    key: "updateTokens",
    value: function updateTokens(tokens) {
      var store = this.store;
      store.dispatch({
        type: TOKEN_UPDATE_ACTION,
        payload: tokens
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.updateTokens({
        id: null,
        access: null,
        refresh: null
      });
    }
  }, {
    key: "tokens",
    get: function get() {
      var store = this.store,
          storeKey = this.storeKey;

      var tokens = _lodash["default"].get(store.getState(), storeKey);

      return tokens;
    }
  }, {
    key: "id",
    get: function get() {
      return this.tokens.id;
    }
  }, {
    key: "refresh",
    get: function get() {
      return this.tokens.refresh;
    }
  }, {
    key: "access",
    get: function get() {
      return this.tokens.access;
    }
  }]);
  return ReduxTokenStore;
}();

exports["default"] = ReduxTokenStore;